const YES = 'あり';
const NO = 'なし';

export const yesOrNoNumeric = [
  {
    text: YES,
    value: 1,
  },
  {
    text: NO,
    value: 0,
  },
];

export const yesOrNoString = [
  {
    text: YES,
    value: '1',
  },
  {
    text: NO,
    value: '0',
  },
];

export const yesOrNoBool = [
  {
    text: 'はい',
    value: '1',
  },
  {
    text: 'いいえ',
    value: '0',
  },
];

export const engineTypeOptions = [
  { value: 'GASOLINE', text: 'ガソリン' },
  { value: 'DIESEL', text: 'ディーゼル' },
  { value: 'LPG', text: 'LPG' },
  { value: 'ELECTRO', text: '電気' },
  { value: 'OTHER', text: 'その他' },
];

export const climateOptions = [
  { value: 'CLIMATE_NORMAL', text: '正常' },
  { value: 'CLIMATE_ABNORMAL', text: '異常' },
  { value: 'CLIMATE_NOT_INSTALL', text: '装備なし' },
];

export const transmissionOptions = [
  { value: 'AT', text: 'AT' },
  { value: 'MT', text: 'MT' },
];

export const carHistoryOptions = [
  { value: '2', text: '自家用' },
  { value: '3', text: '事業用' },
  { value: '4', text: 'リース' },
  { value: '5', text: 'レンタ' },
];

export const externalSuspensionOptions = [
  { value: 'NO', text: 'なし' },
  { value: 'HIGH_SUSPENSION', text: '車高調' },
  { value: 'LOWERED_SUSPENSION', text: 'ダウンサス' },
];

export const transmissionMovementOptions = [
  {
    value: 'NORMAL',
    text: '正常',
  },
  {
    value: 'ABNORMAL',
    text: '異常',
  },
];

export const timingBeltExchangeValueTypeOptions = [
  {
    text: 'キロ',
    value: '1',
  },
  {
    text: 'マイル',
    value: '2',
  },
];

export const importOptions = [
  {
    text: '正規',
    value: '0',
  },
  {
    text: '並行',
    value: '1',
  },
];

export const transmissionDriveOptions = [
  {
    value: '2WD',
    text: '2WD',
  }, {
    text: '4WD',
    value: '4WD',
  },
];

export const colors = [
  { value: '1433483', text: 'アイボリ', id: 'ivory' },
  { value: '1433480', text: 'アカ', id: 'red' },
  { value: '52', text: 'イエロー', id: 'yellow' },
  { value: '351', text: 'オレンジ', id: 'orange' },
  { value: '53', text: 'グリーン', id: 'green' },
  { value: '51', text: 'グレー', id: 'grey' },
  { value: '349', text: 'ゴールド', id: 'gold' },
  { value: '1433481', text: 'コン', id: '#233B6C' },
  { value: '54', text: 'シルバー', id: 'silver' },
  { value: '1433479', text: 'シロ', id: 'white' },
  { value: '353', text: 'パープル', id: 'purple' },
  { value: '1433484', text: 'パール', id: '#EAE0C8' },
  { value: '354', text: 'ピンク', id: 'pink' },
  { value: '350', text: 'ブラウン', id: 'brown' },
  { value: '28', text: 'ブラック', id: 'black' },
  { value: '50', text: 'ブルー', id: 'blue' },
  { value: '346', text: 'ベージュ', id: 'beige' },
  { value: '1433482', text: 'ワイン', id: 'wine' },
];

const intColors = colors.map(c => ({ ...c, value: parseInt(c.value, 10) }));

const colorsByValue = value => colors.find(s => s.value === value);

export function getColor(value) {
  return colorsByValue(value) ? colorsByValue(value).text : '';
}

export const originalColors = [
  { value: 1, text: '同色' },
  ...intColors,
  { value: 9999, text: '不明' },
];

export const yesOrNo = [
  {
    text: YES,
    value: 'YES',
  },
  {
    text: NO,
    value: 'NO',
  },
];

export const smallOrBig = [
  { value: 'SMALL', text: '小' },
  { value: 'BIG', text: '大' },
  { value: 'NO', text: NO },
];

export const detailsBasic = [
  {
    text: '正常',
    value: 'NORMAL',
  },
  {
    text: '異常',
    value: 'FAULT',
  },
];

export const details = [
  ...detailsBasic,
  {
    text: '不動',
    value: 'IMMOVABLE',
  },
];

export const conditionOptions = [
  { value: 'S', text: 'S' },
  { value: '5', text: '5' },
  { value: '4.5', text: '4.5' },
  { value: '4', text: '4' },
  { value: '3.5', text: '3.5' },
  { value: '3', text: '3' },
  { value: '2', text: '2' },
  { value: '1', text: '1' },
  { value: 'R', text: 'R' },
  { value: 'X', text: 'X' },
  { value: 'T', text: 'T' },
  { value: '事故現状車', text: '事故現状車' },
];

export const evaluationOptions = [
  { value: 'A', text: 'A' },
  { value: 'B', text: 'B' },
  { value: 'C', text: 'C' },
  { value: 'D', text: 'D' },
];

export const slidingDoorsOptions = [
  { value: 'NONE', text: 'なし' },
  { value: 'ONE', text: '片側' },
  { value: 'BOTH', text: '両側' },
];

export const powerSeatOptions = [
  { value: 'NONE', text: 'なし' },
  { value: 'DRIVER', text: '運転席のみ' },
  { value: 'FRONT_ROW', text: '前列のみ' },
  { value: 'ALL_SEATS', text: '全席' },
];

export const yesOrNoPtsOwners = [
  {
    text: YES,
    value: '1',
  },
  {
    text: NO,
    value: '0',
  },
];

export const odorOptions = [
  { value: 'PET', text: 'ペット' },
  { value: 'TABACOO', text: 'タバコ' },
  { value: 'OTHER', text: 'その他' },
  { value: 'NO', text: NO },
];

export const oilLeakOptions = [
  { value: 'OOZE', text: 'にじみ' },
  { value: 'LEAK', text: '漏れ' },
  { value: 'NO', text: NO },
];

export const hailDamageOptions = [
  { value: 'YES', text: 'はい' },
  { value: 'NO', text: 'いいえ' },
];

export default {
  yesOrNo: [
    {
      text: YES,
      value: 'YES',
    },
    {
      text: NO,
      value: 'NO',
    },
  ],
  details: [
    {
      text: '正常',
      value: 'NORMAL',
    },
    {
      text: '異常',
      value: 'FAULT',
    },
    {
      text: '不動',
      value: 'IMMOVABLE',
    },
  ],
};

export const seatMaterial = [
  {
    value: 'CLOTH',
    text: '布',
  },
  {
    value: 'FULL_LEATHER',
    text: 'フルレザー',
  },
  {
    value: 'HALF_LEATHER',
    text: 'ハーフレザー',
  },
  {
    value: 'SEAT_COVER',
    text: 'シートカバー',
  },
  {
    value: 'OTHER',
    text: 'その他',
  },
];

export const speedometerChangesOptions = [
  { value: '0', text: NO },
  { value: '2', text: 'メーター交換' },
  { value: '1', text: '走行不明' },
  { value: '3', text: 'メーター改ざん' },
];

export const hoursOptions = [
  { value: '08', text: '08' },
  { value: '09', text: '09' },
  { value: '10', text: '10' },
  { value: '11', text: '11' },
  { value: '12', text: '12' },
  { value: '13', text: '13' },
  { value: '14', text: '14' },
  { value: '15', text: '15' },
  { value: '16', text: '16' },
  { value: '17', text: '17' },
  { value: '18', text: '18' },
  { value: '19', text: '19' },
  { value: '20', text: '20' },
  { value: '21', text: '21' },
  { value: '22', text: '22' },
];

export const minutesOptions = [
  { value: '00', text: '00' },
  { value: '15', text: '15' },
  { value: '30', text: '30' },
  { value: '45', text: '45' },
];

export const labels = {
  brandId: '車名（メーカー）',
  year: '年式',
  modelId: 'モデル・車種名',
  modificationId: 'グレード・パッケージ（マッチング結果）',
  modificationExt: 'グレード・パッケージ（QRコード読み取り情報）',
  sts: '初年度登録年月',
  inspectionDate: '車検有効期限',
  plate: '型式',
  vin: '車台番号',
  reimportVin: 'シリアル番号',
  numberPlate: 'ナンバープレート',
  engineType: '燃料の種類',
  seats: '乗車定員',
  engine: '総排気量',
  carHistory: '車歴',
  recyclingDeposit: 'リサイクル預託金',
  serviceBook: '取説',
  serviceWarranty: '保証書',
  recordBook: '整備手帳',
  insurance: '自賠責証書',
  colorId: '外装色',
  colorOriginal: '外装色No.',
  colorChanged: '全塗装',
  transmissionDrive: '駆動',
  isAutotruck: '貨物',
  differentRearTiresSize: '前後タイヤサイズ違い',
  sizeOfRearTires: 'リヤタイヤサイズ',
  speedometerChanges: '走行不明・メーター交換・改ざん',
  importOfficial: '正規・並行',
  climate: '冷房',
  description: '具体的に',
  transmission: 'シフト',
  transmissionMovement: '動作確認',
  timingBeltExchangeHistory: 'タイミングベルト交換歴',
  timingBeltExchange: 'タイミングベルト交換時期',
  timingBeltExchangeValue: 'タイミングベルト交換時点距離',
  originalColorId: '元色',
  timingBeltExchangeValueType: 'タイミングベルト交換時点距離（キロ・マイル）',

  deliveryTime: '車両引き渡し時期',
  documentHandoverTime: '書類引き渡し時期',

  pS: 'パワーステアリング(P/S)',
  pW: 'パワーウィンドウ(P/W)',
  electricExteriorMirrors: '電動格納式ミラー',
  sR: 'サンルーフ(S/R)',
  tv: 'TV',
  sheetMaterial: 'シート',
  aW: 'アルミホイール(A/W)',
  NAVIGATION: 'ナビ',
  navigation: 'ナビ',

  bodyFrontRight: '右フロント',
  bodyFrontLeft: '左フロント',
  bodyRearLeft: '左リア',
  leftStep: 'ステップ左',
  bodyRearRight: '右リア',
  rightStep: 'ステップ右',
  roofFront: 'ルーフフロント',
  roofBack: 'ルーフリア',
  frontBottom: 'フロント下回',
  rearBottom: 'リア下回り',
  frontLeftWheel: '左フロントタイヤ',
  rearLeftWheel: '左リアタイヤ',
  engineCompartment: 'エンジンルーム',
  interiorPanel: 'ダッシュボード',
  interiorMileage: 'メーター',
  interiorSeatFront: 'フロントシート',
  interiorSeatRear: 'リアシート',
  ceiling: '天井',
  trunk: 'ラゲッジスペース',
  serviceBookKeys: 'ブック関連',
  warrantyCard: '保証書',
  cautionPlate: 'コーションプレート',
  pts: '車検証',
  shakensho: '自動車検査証記録事項',

  pushStrt: 'プッシュスタート',
  KEYLESS: 'キーレス',
  camera360: '360（全方位）カメラ',
  camera360MovementConfirm: '動作確認（カメラ)',
  cameraBack: 'バックカメラ',
  cameraFront: 'フロントカメラ',
  cameraSide: 'サイドカメラ',
  flipDownMonitor: 'フリップダウンモニター',
  powerBackDoor: 'パワーバックドア',
  slidingDoors: 'パワースライドドア',
  slidingDoorsMovementConfirm: '動作確認',
  slidingDoorsMovementConfirmDescription: '具体的に',
  powerSeat: 'パワーシート',
  powerSeatMovementConfirm: '動作確認',
  powerSeatMovementConfirmDescription: '具体的に',
  seatHeater: 'シートヒーター',
  seatHeaterMovementConfirm: '動作確認',
  seatHeaterMovementConfirmDescription: '具体的に',
  others: 'その他',
  ptsOwners: 'ワンオーナー',

  exteriorSmallWounds: '小傷 / うす傷(外装全体)',
  exteriorFaded: '色あせ(外装全体)',
  petHair: 'ペット毛',
  ODOR: '匂い',
  odorOther: '具体的に',
  interiorScratch: '小傷 / スレ(内装全体)',
  interiorDirt: '汚れ',
  interiorYellowed: '黄ばみ(内装全体)',
  externalSuspension: '社外足回り装備',
  engineAbnormalSound: 'エンジン異音',
  engineRustAndCorrosion: 'エンジンルームサビ・腐食',
  belowRustAndCorrosion: '下回りサビ・腐食',
  suspensionSystemRustCorrosion: '足まわりサビ・腐食',
  oilLeak: 'オイル系漏れ',
  warningLight: '警告灯',
  hailDamagedCar: '雹害車',

  hasRepairHistory: '骨格部位に異常(修正・交換・歪み)',

  myPageStep: 'マイページステップ',
  otherNormalEquipment: 'その他装備品',
  otherFaultEquipment: '故障装備の申告',
  otherDamages: 'その他損傷（外装・内装）',

};

export const MODIFICATION_OTHER = 666666;

export const steps = [
  { id: 'RakutenLanding', value: '1-1/3 楽天一括LP', order: 1 },
  { id: 'BeforeInspection.InspectionInfo', value: '1-2/3 検査申込中', order: 2 },
  { id: 'BeforeInspection.InspectionInfoConfirmation', value: '1-3/3 検査申込完了', order: 3 },
  { id: 'HowWorkAuction', value: '2-1/6 オークションのご案内', order: 4 },
  { id: 'RootPageFillingInfo.PersonalInfo', value: '2-2/6 個人情報入力', order: 5 },
  { id: 'RootPageFillingInfo.CarHolderInfo', value: '2-3/6 車両情報入力', order: 6 },
  { id: 'RootPageFillingInfo.CarCondition', value: '2-4/6 車両状態申告', order: 7 },
  { id: 'RootPageFillingInfo.PersonalInfoConfirmation', value: '2-5/6 検査前入力確認', order: 8 },
  { id: 'RootPageFillingInfo.Completion', value: '2-6/6 検査前入力完了', order: 9 },
  { id: 'SelfInspection.Thanks', value: '2-6/6 検査前入力完了', order: 10 },
  { id: 'SelfInspection.Intro', value: 'ｾ-1/11 セルフ検査開始', order: 11 },
  { id: 'SelfInspection.Equipment', value: 'ｾ-2/11 セルフ引渡し可能時期など', order: 12 },
  { id: 'SelfInspection.ExteriorDamage', value: 'ｾ-3/11 セルフ損傷箇所（外装）', order: 13 },
  { id: 'SelfInspection.InteriorDamage', value: 'ｾ-4/11 セルフ損傷箇所（内装）', order: 14 },
  { id: 'SelfInspection.CarPhotos', value: 'ｾ-5/11 セルフ画像の登録（基本）', order: 15 },
  { id: 'SelfInspection.DamagePhotos', value: 'ｾ-6/11 セルフ画像の登録（損傷）', order: 16 },
  { id: 'SelfInspection.AppealPointPhotos', value: 'ｾ-7/11 セルフ画像の登録（装備）', order: 17 },
  { id: 'SelfInspection.Scan', value: 'ｾ-8-1/11 セルフ車両情報（QR読取）', order: 18 },
  { id: 'SelfInspection.CarDetails', value: 'ｾ-8-2/11 セルフ車両情報（入力）', order: 19 },
  { id: 'SelfInspection.Confirmation', value: 'ｾ-9/11 セルフ入力内容の確認', order: 20 },
  { id: 'SelfInspection.Terms', value: 'ｾ-10/11 セルフサービス利用の同意', order: 21 },
  { id: 'SelfInspection.Complete', value: 'ｾ-11/11 セルフ登録完了', order: 22 },
  { id: 'RootPageBeforeAuction.ClientPrice', value: '3-1/4 ウリキリ価格設定', order: 23 },
  { id: 'RootPageBeforeAuction.CarTransfer', value: '3-2/4 車と書類の引き渡し', order: 24 },
  { id: 'RootPageBeforeAuction.ConfirmationInfo', value: '3-3/4 ウリキリ・引き渡し内容の確認', order: 25 },
  { id: 'RootPageBeforeAuction.Completion', value: '3-4/4 オークション前手続き完了', order: 26 },
];

export const stepById = id => steps.find(s => s.id === id);

export const onOff = [
  { text: 'ON', value: true },
  { text: 'OFF', value: false },
];
export const onOffByText = text => onOff.find(s => s.text === text);
export const onOffByValue = value => onOff.find(s => s.value === value);

export const inspectionTypes = [
  {
    text: '通常',
    value: '0',
  },
  {
    text: 'セルフ',
    value: '1',
  },
];

export const cities = [
  { value: 1389, text: '北海道' },
  { value: 1394, text: '青森県' },
  { value: 1395, text: '岩手県' },
  { value: 1380, text: '宮城県' },
  { value: 1396, text: '秋田県' },
  { value: 1397, text: '山形県' },
  { value: 1378, text: '福島県' },
  { value: 1393, text: '茨城県' },
  { value: 1398, text: '栃木県' },
  { value: 1399, text: '群馬県' },
  { value: 1369, text: '埼玉県' },
  { value: 1370, text: '千葉県' },
  { value: 1318, text: '東京都' },
  { value: 1368, text: '神奈川県' },
  { value: 1400, text: '新潟県' },
  { value: 1401, text: '富山県' },
  { value: 1391, text: '石川県' },
  { value: 1402, text: '福井県' },
  { value: 1390, text: '山梨県' },
  { value: 1403, text: '長野県' },
  { value: 1376, text: '岐阜県' },
  { value: 1373, text: '静岡県' },
  { value: 1379, text: '愛知県' },
  { value: 1386, text: '三重県' },
  { value: 1404, text: '滋賀県' },
  { value: 1405, text: '京都府' },
  { value: 1374, text: '大阪府' },
  { value: 1377, text: '兵庫県' },
  { value: 1406, text: '奈良県' },
  { value: 1407, text: '和歌山県' },
  { value: 1408, text: '鳥取県' },
  { value: 1409, text: '島根県' },
  { value: 1410, text: '岡山県' },
  { value: 1411, text: '広島県' },
  { value: 1412, text: '山口県' },
  { value: 1413, text: '徳島県' },
  { value: 1414, text: '香川県' },
  { value: 1415, text: '愛媛県' },
  { value: 1416, text: '高知県' },
  { value: 1392, text: '福岡県' },
  { value: 1417, text: '佐賀県' },
  { value: 1418, text: '長崎県' },
  { value: 1419, text: '熊本県' },
  { value: 1420, text: '大分県' },
  { value: 1421, text: '宮崎県' },
  { value: 1422, text: '鹿児島県' },
  { value: 1423, text: '沖縄県' },
];

export const citiesById = id => (cities.find(b => `${b.value}` === `${id}`) || {}).text || '';

export const CAMPAIGN_ID_ORGANIC = '1374599';
export const CAMPAIGN_ID_VALUE_CREATION = '1372663';
export const CAMPAIGN_ID_RENTRACKS = '1372664';
export const CAMPAIGN_ID_KURUMO = '1372665';
export const CAMPAIGN_ID_AFFILIATE_POINT = '1';
export const CAMPAIGN_ID_AFFILIATE_SEO = '2';
export const CAMPAIGN_ID_DIRECT_MAIL = '6';
export const CAMPAIGN_ID_PERSONAL_APPOINTMENT = '3';
export const CAMPAIGN_ID_PARTNER = '1432414';
export const CAMPAIGN_ID_SONPO = '1432415';
export const CAMPAIGN_ID_STAFF = '5';
export const CAMPAIGN_ID_TEST = '1407187';
export const CAMPAIGN_ID_RAKUTEN = '6666666';

export const sourceTypes = [
  { value: CAMPAIGN_ID_ORGANIC, text: 'Organic' },
  { value: '1374594', text: 'Organic（入電）' },
  { value: '1372662', text: 'GOO-NET' },
  { value: '1434646', text: 'GOO-NET（入電）' },
  { value: CAMPAIGN_ID_RAKUTEN, text: '楽天一括' },
  { value: CAMPAIGN_ID_VALUE_CREATION, text: 'バリュークリエーション' },
  { value: CAMPAIGN_ID_RENTRACKS, text: 'RENTRACKS' },
  { value: CAMPAIGN_ID_KURUMO, text: 'KuRuMo' },
  { value: CAMPAIGN_ID_AFFILIATE_POINT, text: 'アフィリエイト(ポイント)' },
  { value: CAMPAIGN_ID_AFFILIATE_SEO, text: 'アフィリエイト(SEO)' },
  { value: CAMPAIGN_ID_DIRECT_MAIL, text: 'ダイレクトメール問い合わせ' },
  { value: CAMPAIGN_ID_SONPO, text: '楽天損保' },
  { value: '1464914', text: 'ANA' },
  { value: '1470509', text: 'JAL' },
  { value: CAMPAIGN_ID_PARTNER, text: 'パートナー出品（おまかせ）' },
  { value: CAMPAIGN_ID_PERSONAL_APPOINTMENT, text: '自己集客案件（検査員）' },
  { value: '4', text: '社員紹介（三井物産）' },
  { value: CAMPAIGN_ID_STAFF, text: '社員紹介（楽天）' },
  { value: '1488149', text: '自社出品' },
  { value: '1156603', text: 'その他' },
  { value: CAMPAIGN_ID_TEST, text: 'TEST' },
];

export const sourceTypeById = id => (sourceTypes.find(b => `${b.value}` === `${id}`) || {}).text || '';

export const mileagesById = {
  40: '3万キロ以下',
  43: '6万キロ以下',
  45: '10万キロ以下',
  47: '15万キロ以下',
  217: '15万キロ以上',
};

export const nonResizeImages = [
  'pts',
  'driver_license_front',
  'driver_license_back',
  'service_book_keys',
  'warranty_card',
];

export const aiInspectionStatuses = {
  INSPECTION_STARTED: 'inspection_started',
  AWAITING_REDIRECTION: 'awaiting_redirection',
  INSPECTION_POSTPONED: 'inspection_postponed',
  REDIRECTED: 'redirected',
  INSPECTION_PROCESS: 'inspection_process',
  INSPECTION_SUCCESS: 'inspection_success',
  INSPECTION_FAILED: 'inspection_failed',
  INSPECTION_COMPLETED: 'inspection_completed',
};

export const aiInspectionErrorCodes = {
  URL_TIME_LIMIT: 'ERR-001',
  INSPECTION_TIME_LIMIT: 'ERR-002',
};



// WEBPACK FOOTER //
// ./src/options.js